<div [class]="containerClass()" aria-hidden="true">
  <svg
    [style]="iconStyle()"
    [class]="svgClass()"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g id="minus"><path d="M20,13H4a1,1,0,0,1,0-2H20a1,1,0,0,1,0,2Z" /></g>
  </svg>
</div>
